import { useState, useEffect } from 'react';

const noop = () => undefined;
const ssrMatchMedia = {
  media: '',
  matches: false,
  onchange: noop,
  addListener: noop,
  removeListener: noop,
  addEventListener: noop,
  removeEventListener: noop,
  dispatchEvent: _ => true
};
/**
 * Returns a sensor hook that tracks state of a CSS media query.
 * @param effect Desired type of Effect hook
 * @returns useMedia hook
 */
const createUseMedia = effect => (query, defaultState = false) => {
  const [hasMatch, setMatch] = useState(defaultState);
  effect(() => {
    let isMounted = true;
    const mediaQuery = typeof window !== 'undefined' ? window.matchMedia(query) : ssrMatchMedia;
    const onChange = () => {
      if (!isMounted) {
        return;
      }
      setMatch(Boolean(mediaQuery.matches));
    };
    // TODO: can be changed to addEventListener once mobile safari implements is
    // @see https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
    mediaQuery.addListener(onChange);
    setMatch(Boolean(mediaQuery.matches));
    return () => {
      isMounted = false;
      mediaQuery.removeListener(onChange);
    };
  }, [query]);
  return hasMatch;
};
const useMedia = createUseMedia(useEffect);

export { useMedia as default, useMedia };
//# sourceMappingURL=useMedia.js.map
